import styled from 'styled-components';
import { NavBarHeight, SubNavBarHeightMobile } from '../../../../const';
import { Container } from '../../../gridSystem';

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
export const ActionWrapper = styled(Container)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
`;

export const MainContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .logout {
    margin-left: 10px;
    cursor: pointer;
  }

  @media ${(props) => props.theme.device.tabletL} {
    &.logout {
      margin-left: 9px;
    }
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 60px;
  padding: 0;
  position: relative;

  @media ${(props) => props.theme.device.tabletL} {
    flex-direction: column;
    height: calc(${NavBarHeight}px + ${SubNavBarHeightMobile}px);
  }
`;

export const IconWrapperPeople = styled.div`
  background-color: ${(props) => props.theme.colors.black};
  width: 70px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.colors.doveGray};
  }

  @media ${(props) => props.theme.device.tabletL} {
    height: 45px;
    margin-right: 5px;
  }
`;

export const NavBarContainer = styled.header.attrs(() => ({
  className: 'header header-wrapper',
}))`
  position: sticky;
  top: 0;
  width: 100%;
  height: ${NavBarHeight}px;
  color: ${(props) => props.theme.colors.white};
  z-index: ${(props) => props.theme.zIndex.navBar};
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.bgHeader};

  &.header-wrapper {
    width: 100%;
    margin: 0;
    z-index: ${(props) => props.theme.zIndex.headerWrapper};
    margin-left: auto;
  }

  @media ${(props) => props.theme.device.tabletL} {
    height: 120px;
    div {
      div {
        div {
          .close-modal {
            outline: none;
            animation: fadein 1s;
            background-color: white;
            border: none;
            display: block;
            padding: 20px;
            position: absolute;
            right: 10px;
            top: 10px;
            width: 20px;
            height: 20px;
            z-index: ${(props) => props.theme.zIndex.closeModal};

            &::after {
              content: '';
              position: absolute;
              transform: rotate(-45deg);
              background-color: ${(props) => props.theme.colors.white};
              height: 20px;
              width: 1px;
              top: 10px;
              z-index: ${(props) => props.theme.zIndex.closeModal};
            }

            &::before {
              content: ' ';
              position: absolute;
              transform: rotate(45deg);
              background-color: ${(props) => props.theme.colors.white};
              height: 20px;
              width: 1px;
              top: 10px;
              z-index: ${(props) => props.theme.zIndex.closeModal};
            }
          }
        }
      }
    }
  }

  @media ${(props) => props.theme.device.mobileL} {
    min-height: 110px;
    div {
      /* padding: 0; */
      div {
        div {
          //margin-right: 0px;
          //margin-left: 0px;
        }
      }
    }
  }
`;

export const LoginWrapper = styled.button`
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 0 20px;
  cursor: pointer;
  height: ${NavBarHeight}px;
  background-color: ${(props) => props.theme.colors.bgSubHeader};

  svg {
    stroke: ${(props) => props.theme.colors.bgHeader};
  }

  &:hover,
  &:focus-visible {
    svg {
      stroke: ${(props) => props.theme.colors.btnHover};
    }
    .h3 {
      position: relative;
      &::after {
        content: '';
        display: block;
        height: 0.4px;
        width: 100%;
        position: absolute;
        bottom: 3px;
        left: 0;
        background-color: ${(props) => props.theme.colors.white};
      }
    }
  }
`;

export const IconWrapperLogin = styled.div`
  padding: 4px;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 100%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
